<div class="sidebar-tab-page-content copo-no-user-select sidenav-content" cdkScrollable>
	<copo-panel-header [titleHeaderText]="'news.news-list' | translate" (click)="back()"></copo-panel-header>
	<div class="grid-6 copo-container" copoVirtualScroller [dataId]="dataId" #scroller="copoVirtualScroller"
		(moreDataNeeded)="onMoreDataNeeded($event.index, $event.limit, $event.provideData)">
		<ng-container *ngFor="let news of scroller.list">
			<div class="grid-container grid-column-one-full card-block">
				<div class="card-column">
					<div class="card-title">{{news.title}}</div>
					<div class="news-list">
						<p class="card-infos-block" [innerHTML]="news.content"></p> 
					</div>
					<div class="news-from-to-date" translate>
						filter.number.from&nbsp;
							<span> {{news.from | date: 'dd/MM/yyyy' }}</span>
						<span translate>&nbsp;filter.date.to&nbsp;
							<span >{{news.to | date: 'dd/MM/yyyy'}} </span>
						</span>
					</div>
					<div class="card-block-footer">
						<button type="button" mat-button color="primary" [routerLink]="['/home/news-card', news.id]">
							<span translate>order-tracking.card.delivery-date.view-details</span>
							<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
						</button>
					</div>
				</div>
			</div>
		</ng-container>
		<copo-loading-spinner class="grid-column-one-full" *ngIf="scroller.loading"></copo-loading-spinner>
		<div translate class="empty-page-text grid-column-one-full"
			*ngIf="!scroller.loading && scroller.list.length === 0">order-tracking.no.result</div>
	</div>
</div>